"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var context = /*#__PURE__*/_react.default.createContext(null);

context.displayName = 'NavbarContext';
var _default = context;
exports.default = _default;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./~/react-bootstrap/cjs/NavbarContext.js
// module id = 27
// module chunks = 0